export default "__VITE_ASSET__DvlP62q7__"